import serialize from 'serialize-javascript';
import jsStringEsc from 'js-string-escape';
export function getAdsSSRConfig(session) {
    var _session_features, _session_features1;
    if (!session.adsEnabled) {
        return {
            shouldIncludeGak: false,
            shouldIncludeFreestar: false
        };
    }
    if ((_session_features = session.features) === null || _session_features === void 0 ? void 0 : _session_features.includes('ads_freestar')) {
        var _session_features2, _session_features3;
        return {
            shouldIncludeGak: false,
            shouldIncludeFreestar: true,
            adsDebug: (session === null || session === void 0 ? void 0 : (_session_features2 = session.features) === null || _session_features2 === void 0 ? void 0 : _session_features2.includes('ads_debug')) ? true : false,
            gakContext: toJsonString({
                features: session === null || session === void 0 ? void 0 : (_session_features3 = session.features) === null || _session_features3 === void 0 ? void 0 : _session_features3.reduce((p, c)=>{
                    p[c] = true;
                    return p;
                }, {})
            })
        };
    }
    return {
        shouldIncludeGak: true,
        shouldIncludeFreestar: false,
        gakContext: toJsonString({
            features: session === null || session === void 0 ? void 0 : (_session_features1 = session.features) === null || _session_features1 === void 0 ? void 0 : _session_features1.reduce((p, c)=>{
                p[c] = true;
                return p;
            }, {})
        })
    };
}
export function isSSR() {
    return typeof window === 'undefined';
}
function jsStringEscape(json) {
    const result = jsStringEsc(json);
    return `"${result.replace(/<\/(script|style)/gi, '<\\/$1').replace(/<!--/g, '\\u003C!--')}"`;
}
export function toJsonString(jsObject, newrelic = null, newrelicSegmentName = '') {
    if (newrelic) {
        const segment = newrelicSegmentName || 'TO_JSON';
        return newrelic.startSegment(segment, true, ()=>jsStringEscape(serialize(jsObject, {
                isJSON: true
            })));
    }
    return jsStringEscape(serialize(jsObject, {
        isJSON: true
    }));
}
